import SwitchComponent from './switch';

export default SwitchComponent;
